import { Button, CloseButton, Dialog, HStack, Portal, Text, Textarea } from "@chakra-ui/react";

const AddLeadNoteModal = ({ isOpen, onClose, noteContent, setNoteContent, onSubmit, isLoading }) => (
    <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
        <Portal>
            <Dialog.Backdrop />
            <Dialog.Positioner p={4}>
                <Dialog.Content
                    bg="bg.card" color="white" borderColor="border.primary" border="1px solid"
                    w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                    overflowY="auto" borderRadius={12}
                >
                    <Dialog.Body pt={6} pb={6} px={6}>
                        <Text fontWeight={700} fontSize="lg" mb={4}>Dodaj notatkę</Text>
                        <Textarea
                            placeholder="Treść notatki..."
                            value={noteContent}
                            onChange={(e) => setNoteContent(e.target.value)}
                            rows={5}
                            bg="bg.secondary" border="1px solid" borderColor="border.primary" color="white"
                            _placeholder={{ color: "text.grey" }} resize="vertical" mb={4}
                        />
                        <HStack justify="flex-end" gap={2}>
                            <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                            <Button variant="primary" size="sm" loading={isLoading} disabled={!noteContent.trim()} onClick={onSubmit}>
                                Dodaj
                            </Button>
                        </HStack>
                    </Dialog.Body>
                    <Dialog.CloseTrigger asChild>
                        <CloseButton size="sm" position="absolute" top="2" right="2" color="text.grey" />
                    </Dialog.CloseTrigger>
                </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>
);

export default AddLeadNoteModal;
